import moment from 'moment'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { bannerNotificationManagementAPI } from '@services/api/bannerNotificationManagementAPI'

export const fetchBannerNotificationList = createAsyncThunk(
  'bannerNotificationManagement/fetchBannerNotificationList',
  async (params: TBannerNotificationManagementAPI.Params.FetchList, { rejectWithValue }) => {
    try {
      const response = await bannerNotificationManagementAPI.fetchList(params)
      return response.data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const createNotification = createAsyncThunk(
  'bannerNotificationManagement/createNotification',
  async (data: TBannerNotificationManagement.TState['notificationUpsert']['data'], { rejectWithValue }) => {
    try {
      const response = await bannerNotificationManagementAPI.create(data)
      return response.data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const updateNotification = createAsyncThunk(
  'bannerNotificationManagement/updateNotification',
  async (data: TBannerNotificationManagement.TState['notificationUpsert']['data'], { rejectWithValue }) => {
    try {
      const response = await bannerNotificationManagementAPI.update(data)
      return response.data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const fetchSingle = createAsyncThunk(
  'bannerNotificationManagement/fetchSingle',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await bannerNotificationManagementAPI.fetchSingle(id)
      response.data.data.startDate = moment(response.data.data.startDate).format('YYYY-MM-DD')
      response.data.data.endDate = moment(response.data.data.endDate).format('YYYY-MM-DD')
      return response.data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)
